import { NO, YES } from "uicore-ts"


export type RHResponsiveText = {
    regular: string
    compact: string
}

export function isRHCompactViewport(): boolean {
    const viewportWidth = currentRHViewportWidth()
    if (viewportWidth <= 1366) {
        return YES
    }
    return NO
}

export function labelForRHViewport(label: RHResponsiveText): string {
    if (isRHCompactViewport()) {
        return label.compact
    }
    return label.regular
}

function currentRHViewportWidth(): number {
    if (typeof window === "undefined") {
        return Number.MAX_SAFE_INTEGER
    }
    if (window.innerWidth) {
        return window.innerWidth
    }
    if (document.documentElement?.clientWidth) {
        return document.documentElement.clientWidth
    }
    return Number.MAX_SAFE_INTEGER
}
